module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-image-lib-upload.53551764.svg";